import * as area from './line-area/area'
import * as bar from './bar'
import * as beaker from './beaker'
import * as bubbleMap from './map'
import * as cycle from './cycle'
import * as donut from './pie' // uses pie code, just adjusts the styli
import * as funnel from './funnel'
import * as filledMap from './map'
import * as line from './line-area/line'
import * as pie from './pie'
import * as polar from './polar'
import * as process from './process'
import * as pyramid from './pyramid'
import * as referenceBand from './reference-band'
import * as regression from './regression'
import * as spikeMap from './map'
import * as timeline from './timeline'
import * as treemap from './treemap'
import * as waffle from './waffle'

export default {
  area,
  bar,
  beaker,
  'bubble-map': bubbleMap,
  cycle,
  donut,
  'filled-map': filledMap,
  funnel,
  line,
  pie,
  polar,
  process,
  pyramid,
  'reference-band': referenceBand,
  regression,
  'spike-map': spikeMap,
  timeline,
  treemap,
  waffle
}
